import { render, staticRenderFns } from "./SearchAuto.vue?vue&type=template&id=7254ffc6&"
import script from "./SearchAuto.vue?vue&type=script&lang=js&"
export * from "./SearchAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports